import rushAcademy from "@/services/rush.academy";
import notification from "@/services/notification";
import { getField, updateField } from "vuex-map-fields";

export default {
  namespaced: true,
  state: {
    loading: false,
    errors: null,
    rush_academy: null
  },
  getters: {
    getField,
    isLoading: state => state.loading,
    errors: state => state.errors,
    rush_academy: state => state.rush_academy
  },
  mutations: {
    updateField,
    setLoading(state, value) {
      state.loading = value;
    },
    setErrors(state, errors) {
      state.errors = errors;
    },
    setRushAcademy(state, data) {
      data.tutorial_progress.map(video => video['is_playing'] = false);
      state.rush_academy = data;
    }
  },
  actions: {
    async getRushAcademy({ commit }) {
      commit("setLoading", true);
      commit("setErrors", null);
      try {
        const { data } = await rushAcademy.getRushAcademy();
        commit("setRushAcademy", data);
      } catch (errors) {
        const { message } = errors.errors;
        commit("setErrors", errors.errors);
      } finally {
        commit("setLoading", false);
      }
    },
    async saveRushAcademyProgress({ commit }, payload) {
      commit("setLoading", true);
      commit("setErrors", null);
      try {
        await rushAcademy.saveRushAcademyProgress(payload);
      } catch (errors) {
        commit("setErrors", errors.errors);
      } finally {
        commit("setLoading", false);
      }
    }
  }
}
